import React from 'react';
import Segments from './Segments';
import { ApRadio } from '@alixpartners/ui-components';

import { InfoTooltip } from './InfoTooltip';

import {
	Wrapper,
	SectionWrapper,
	Section,
	RowSection,
	Title,
	Description,
	RadioWrapper,
} from './TailSpendSegments.styles';

export const CALCULATION_TYPES = {
	percentage: 0,
	perVendor: 3,
	accumulative: 1,
	vendorsCount: 2,
};

const options = [
	{
		name: 'Spend per vendor',
		description:
			'Allocates vendors to a segment based on eachindividual vendor’s total spend.',
		value: CALCULATION_TYPES.perVendor,
	},
	{
		name: 'Percentage of tail spend',
		description:
			'Calculates the vendor’s individual spend as a percentage of tail spend and allocates it to the appropriate segment.',
		value: CALCULATION_TYPES.percentage,
	},
	{
		name: 'Cumulative vendor spend',
		description:
			'Sorts vendors from low to high spend and allocates them to the segment until the threshold cumulative spend value is reached.',
		value: CALCULATION_TYPES.accumulative,
	},
	{
		name: 'Number of vendors',
		description:
			'Sorts vendors from low to high spend and allocates them to the segment from the lowest spend first.',
		value: CALCULATION_TYPES.vendorsCount,
	},
];

export const TailSpendSegments = props => {
	const { calculationType, onChange, currency, unit } = props;

	const handleCalculationTypeChange = e => {
		const newCalculationType = +e.target.value;

		onChange({ calculationType: newCalculationType });
	};
	const currencyUnitProps = { currency, unit };

	if (calculationType === CALCULATION_TYPES.percentage) {
		currencyUnitProps.currency = '%';
		currencyUnitProps.unit = '';
	} else if (calculationType === CALCULATION_TYPES.vendorsCount) {
		currencyUnitProps.currency = '';
		currencyUnitProps.unit = '';
	}

	return (
		<Wrapper>
			<SectionWrapper>
				<Section>
					<Title>Segments</Title>
					<Description>
						1. Select the calculation method for allocating vendors to segments
					</Description>
				</Section>
				<RowSection>
					{options.map(({ name, description, value }) => (
						<RadioWrapper key={name}>
							<ApRadio
								name="radio"
								value={value}
								defaultChecked={calculationType === value}
								onChange={handleCalculationTypeChange}
							>
								{name}
								<InfoTooltip message={description} />
							</ApRadio>
						</RadioWrapper>
					))}
				</RowSection>
			</SectionWrapper>
			<SectionWrapper>
				<Section>
					<Description>2. Define up to six segments</Description>
				</Section>
				<Section>
					<Segments {...props} {...currencyUnitProps} />
				</Section>
			</SectionWrapper>
		</Wrapper>
	);
};

export default TailSpendSegments;
